export const propertyActionStatisticSummaryModel = (data) => ({
    name: data.name,
    value: data.value,
});